import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StructuredData } from "@/components/StructuredData";
import { HomePage } from "@/pages/HomePage";
import { ServicesPage } from "@/pages/ServicesPage";
import { SpecialOffersPage } from "@/pages/SpecialOffersPage";
import { GalleryPage } from "@/pages/GalleryPage";
import { FAQPage } from "@/pages/FAQPage";
import { ContactPage } from "@/pages/ContactPage";
import { QuizPage } from "@/pages/QuizPage";
import { BookInspectionPage } from "@/pages/BookInspectionPage";
import { FreeAssessmentPage } from "@/pages/FreeAssessmentPage";
import { OurServicesPage } from "@/pages/OurServicesPage";
import { ExclusiveDealsPage } from "@/pages/ExclusiveDealsPage";
import { WhyMetalRoofingPage } from "@/pages/WhyMetalRoofingPage";
import { OurWorkPage } from "@/pages/OurWorkPage";
import { PhoneClickPage } from "@/pages/PhoneClickPage";
// Service-specific pages (Third Pass)
import { MetalRoofInstallationPage } from "@/pages/MetalRoofInstallationPage";
import { RoofRepairsPage } from "@/pages/RoofRepairsPage";
import { RoofReplacementPage } from "@/pages/RoofReplacementPage";
import { GutterInstallationPage } from "@/pages/GutterInstallationPage";
import { EmergencyRepairsPage } from "@/pages/EmergencyRepairsPage";
// Admin pages
import { AdminLoginPage } from "@/pages/AdminLoginPage";
import { AdminDashboardPage } from "@/pages/AdminDashboardPage";
import { AdminPhotosPage } from "@/pages/AdminPhotosPage";
import { Toaster } from "@/components/ui/sonner";

// Layout component that conditionally renders Header/Footer
const MainLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    // Set page title and meta description (Priority 8 SEO)
    document.title = "Metal Roofing Sydney | Roof Repairs and Replacement | Dezire Metal Roofing";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Dezire Metal Roofing provides metal roof installation, roof repairs, roof replacement, and guttering services across Greater Sydney. Book a free inspection today.');
    }
  }, []);

  return (
    <div className="App">
      <StructuredData />
      <BrowserRouter>
        <Routes>
          {/* Admin routes - no header/footer */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/photos" element={<AdminPhotosPage />} />
          
          {/* Main site routes with header/footer */}
          <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="/services" element={<MainLayout><ServicesPage /></MainLayout>} />
          <Route path="/special-offers" element={<MainLayout><SpecialOffersPage /></MainLayout>} />
          <Route path="/gallery" element={<MainLayout><GalleryPage /></MainLayout>} />
          <Route path="/faq" element={<MainLayout><FAQPage /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><ContactPage /></MainLayout>} />
          <Route path="/quiz" element={<MainLayout><QuizPage /></MainLayout>} />
          <Route path="/book-inspection" element={<MainLayout><BookInspectionPage /></MainLayout>} />
          <Route path="/free-assessment" element={<MainLayout><FreeAssessmentPage /></MainLayout>} />
          <Route path="/our-services" element={<MainLayout><OurServicesPage /></MainLayout>} />
          <Route path="/exclusive-deals" element={<MainLayout><ExclusiveDealsPage /></MainLayout>} />
          <Route path="/why-metal-roofing" element={<MainLayout><WhyMetalRoofingPage /></MainLayout>} />
          <Route path="/our-work" element={<MainLayout><OurWorkPage /></MainLayout>} />
          <Route path="/call" element={<PhoneClickPage />} />
          {/* Service-specific pages (Third Pass) */}
          <Route path="/services/metal-roof-installation" element={<MetalRoofInstallationPage />} />
          <Route path="/services/roof-repairs" element={<RoofRepairsPage />} />
          <Route path="/services/roof-replacement" element={<RoofReplacementPage />} />
          <Route path="/services/gutter-installation" element={<GutterInstallationPage />} />
          <Route path="/services/emergency-repairs" element={<EmergencyRepairsPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
